module.exports = __webpack_public_path__ + "media/goforajourney/img/mexico-city-tour-649d175f661908f2b473addc045cbb76.webp";